import { get } from "@crunchit/http-client";
import { IFrontendSettings, ILanguageSetting } from "@crunchit/types";
import { getToken, getEnvironment } from "utils/helpers/service";

const api = process.env.REACT_APP_CUSTOMERSETTING_URI || `customersetting.${getEnvironment()}crunchy.ninja/api`;

const CustomerSettingService = {
  getFrontendSettingsByModule: async (moduleId: string) => {
    return get<IFrontendSettings>(`${api}/frontend/module/${moduleId}`, getToken());
  },
  getLanguage: async () => {
    return get<ILanguageSetting>(`${api}/language`, getToken());
  },
};

export default CustomerSettingService;
